import { useTranslation } from "react-i18next";

import { l } from "@clinic/shared/locales/i18n";
import { RestockReminder } from "@shared/components/RestockReminder/RestockReminder";
import type { VariantFragment } from "@shared/data/fragments/VariantFragment/VariantFragment.fragment";

import { usePractitionerVariantNotificationCreateMutation } from "./PractitionerVariantNotificationCreate.mutation";
import { usePractitionerVariantNotificationDeleteMutation } from "./PractitionerVariantNotificationDelete.mutation";

type VariantSplinter = Pick<VariantFragment, "id">;

interface Props {
  variant: VariantSplinter;
  restockReminderOnText?: string;
  isButton?: boolean;
  useAviaryWebMenuItem?: boolean;
}
const PractitionerRestockReminder = ({
  variant,
  restockReminderOnText,
  isButton,
  useAviaryWebMenuItem,
}: Props) => {
  const { t } = useTranslation();

  const [turnOnReminderFn, { loading: turnOnReminderLoading }] =
    usePractitionerVariantNotificationCreateMutation({
      variables: { input: { variantId: variant.id } },
    });

  const [turnOffReminderFn, { loading: turnOffReminderLoading }] =
    usePractitionerVariantNotificationDeleteMutation({
      variables: { input: { variantId: variant.id } },
    });

  return (
    <RestockReminder
      turnOffReminder={turnOffReminderFn}
      turnOffReminderLoading={turnOffReminderLoading}
      turnOnReminder={turnOnReminderFn}
      turnOnReminderLoading={turnOnReminderLoading}
      variant={variant}
      restockReminderOnText={restockReminderOnText}
      isButton={isButton}
      useAviaryWebMenuItem={useAviaryWebMenuItem}
    >
      {t(l.common.GetRestockReminder)}
    </RestockReminder>
  );
};

export { PractitionerRestockReminder };
